import { render, staticRenderFns } from "./UserLoginComponent.vue?vue&type=template&id=2353c38c&scoped=true&"
import script from "./UserLoginComponent.vue?vue&type=script&lang=js&"
export * from "./UserLoginComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserLoginComponent.vue?vue&type=style&index=0&id=2353c38c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353c38c",
  null
  
)

export default component.exports